enum NavigationDirection {
    Up = "Up",
    Down = "Down"
}

export default NavigationDirection;
